<app-polly-manage-analysis-config *ngIf="showAnalysisConfig" [launchSource]="launchSource"
  [isSelectedWorkspace]="isWorkspaceSelected" [currentWorkspace]="currentWorkspace"
  [workspaceSelectorConfig]="analysisConfigPayload" [showLoader]="showLoader"
  (setConfig)="onAnalysisConfigSubmit($event)" (gtmEvent)="gtmEvent.emit($event)" [filterStatus]="filterStatus"
  (createWorkspace)="createWorkspace.emit($event)" (closeComponent)="closeComponent.emit(false)" [datasetInfo]="dataset"
  [currentRepository]="repository" [repoID]="repoID" [applicationTitle]="applicationTitle" [currentRepoV2]="currentRepoV2">
</app-polly-manage-analysis-config>

<app-polly-manage-deprecated-app *ngIf="deprecatedAppName" [appName]="deprecatedAppName"
  (closeComponent)="closeComponent.emit(false)">
</app-polly-manage-deprecated-app>